<!-- scroll-to-top.component.html -->
<button *ngIf="isVisible" (click)="scrollToTop()" class="scroll-to-top-btn">↑</button>
